import { createEvent, createStore } from 'effector';
export const toggleTheme = createEvent();
const initialTheme = localStorage.getItem('theme') || 'light';
export const themeStore = createStore(initialTheme).on(toggleTheme, currentTheme => (currentTheme === 'light' ? 'dark' : 'light'));
themeStore.watch((newTheme) => {
    localStorage.setItem('theme', newTheme);
});
